import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translationRU from './locales/ru/translation.json';
import translationTR from './locales/tr/translation.json';
import translationEN from './locales/en/translation.json';
import translationDE from './locales/de/translation.json';
import translationAR from './locales/ar/translation.json';

const resources = {
  ru: {
    translation: translationRU
  },
  tr: {
    translation: translationTR
  },
  en: {
    translation: translationEN
  },
  de: {
    translation: translationDE
  },
  ar: {
    translation: translationAR
  }
};

// Get saved language or default to Turkish
const getSavedLanguage = () => {
  try {
    const saved = localStorage.getItem('language');
    return saved || 'tr';
  } catch (error) {
    // In case localStorage is not available (incognito mode, etc.)
    return 'tr';
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getSavedLanguage(),
    fallbackLng: 'tr',
    interpolation: {
      escapeValue: false
    },
    react: {
      useSuspense: false,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed'
    }
  });

export default i18n;
